export enum TransactionStatus {
  PENDING = 'PENDING',
  SETTLED = 'SETTLED',
  HOLD = 'HOLD',
}
